"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePriorityTasksTableDynamicColumns = exports.usePriorityTasksTablePageSize = exports.usePriorityTasksTableSort = exports.usePriorityTasksTableSearch = exports.usePriorityTasksTableFilter = exports.selectPriorityTasksTablePageSize = exports.selectPriorityTasksTableSort = exports.selectPriorityTasksTableSearch = exports.selectPriorityTasksTableFilter = exports.selectPriorityTasksTableDynamicColumns = void 0;
const selectors_1 = require("../selectors");
const slice_1 = require("./slice");
const rtk_utils_1 = require("../../rtk-utils");
const table_config_1 = require("../../shared/table-config");
const selectDashboards = (state) => {
    const activeCatalog = (0, selectors_1.selectActiveCatalogRTK)(state);
    return activeCatalog === null || activeCatalog === void 0 ? void 0 : activeCatalog.dashboards;
};
const selectPriorityTasksTable = (state) => {
    const dashboards = selectDashboards(state);
    return dashboards === null || dashboards === void 0 ? void 0 : dashboards.priorityTasksTable;
};
const selectPriorityTasksTableDynamicColumns = (state) => {
    const table = selectPriorityTasksTable(state);
    return (table === null || table === void 0 ? void 0 : table.dynamicColumns) || slice_1.defaultDashboardsSliceState.priorityTasksTable.dynamicColumns;
};
exports.selectPriorityTasksTableDynamicColumns = selectPriorityTasksTableDynamicColumns;
const selectPriorityTasksTableFilter = (state) => {
    const table = selectPriorityTasksTable(state);
    const raw = table === null || table === void 0 ? void 0 : table.filter;
    if (!raw)
        return slice_1.defaultDashboardsSliceState.priorityTasksTable.filter;
    if ((0, table_config_1.isLegacyTableFilter)(raw))
        return (0, table_config_1.hydrateLegacyFilter)(raw);
    return raw;
};
exports.selectPriorityTasksTableFilter = selectPriorityTasksTableFilter;
const selectPriorityTasksTableSearch = (state) => {
    const table = selectPriorityTasksTable(state);
    return (table === null || table === void 0 ? void 0 : table.search) || slice_1.defaultDashboardsSliceState.priorityTasksTable.search;
};
exports.selectPriorityTasksTableSearch = selectPriorityTasksTableSearch;
const selectPriorityTasksTableSort = (state) => {
    const table = selectPriorityTasksTable(state);
    return (table === null || table === void 0 ? void 0 : table.sort) || slice_1.defaultDashboardsSliceState.priorityTasksTable.sort;
};
exports.selectPriorityTasksTableSort = selectPriorityTasksTableSort;
const selectPriorityTasksTablePageSize = (state) => {
    var _a;
    const table = selectPriorityTasksTable(state);
    return (_a = table === null || table === void 0 ? void 0 : table.pageSize) !== null && _a !== void 0 ? _a : slice_1.defaultDashboardsSliceState.priorityTasksTable.pageSize;
};
exports.selectPriorityTasksTablePageSize = selectPriorityTasksTablePageSize;
const usePriorityTasksTableFilter = () => (0, rtk_utils_1.useAppSelector)(exports.selectPriorityTasksTableFilter);
exports.usePriorityTasksTableFilter = usePriorityTasksTableFilter;
const usePriorityTasksTableSearch = () => (0, rtk_utils_1.useAppSelector)(exports.selectPriorityTasksTableSearch);
exports.usePriorityTasksTableSearch = usePriorityTasksTableSearch;
const usePriorityTasksTableSort = () => (0, rtk_utils_1.useAppSelector)(exports.selectPriorityTasksTableSort);
exports.usePriorityTasksTableSort = usePriorityTasksTableSort;
const usePriorityTasksTablePageSize = () => (0, rtk_utils_1.useAppSelector)(exports.selectPriorityTasksTablePageSize);
exports.usePriorityTasksTablePageSize = usePriorityTasksTablePageSize;
const usePriorityTasksTableDynamicColumns = () => (0, rtk_utils_1.useAppSelector)(exports.selectPriorityTasksTableDynamicColumns);
exports.usePriorityTasksTableDynamicColumns = usePriorityTasksTableDynamicColumns;
